import { render, staticRenderFns } from "./widgetScreen.vue?vue&type=template&id=4d670a66&"
import script from "./widgetScreen.vue?vue&type=script&lang=js&"
export * from "./widgetScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports